import { Store } from 'vuex';
import { Getters, Context } from 'vuex-smart-module';
import OrganizationsSharedState from './state';
import OrganizationsStore from '../../store';
import OrganizationsState from '../../store/state';

export default class OrganizationsSharedGetters extends Getters<OrganizationsSharedState> {
  organizations_store!: Context<typeof OrganizationsStore>;

  $init(store: Store<OrganizationsState>): void {
    this.organizations_store = OrganizationsStore.context(store);
  }

  get organizations() {
    return this.organizations_store.state.organizations;
  }

  get user_organization() {
    return this.organizations_store.state.user_orginazation;
  }
}
